import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { SessionContext } from './StoreProvider';
import { getCookie, sendMetricsEvent } from '../helpers';
import { assign as navigate } from '../routes';

import Loader from '../components/atoms/loader';
import Error from '../components/molecules/error';

const Main = ({
  children,
  isLoading,
  setLoader,
  user,
  error,
  pageTitle,
  pageType
}) => {
  const nossaCookie = getCookie('nossaSession');

  useEffect(() => {
    if (!isLoading && pageTitle) {
      sendMetricsEvent({
        eventName: pageTitle,
        pageview: true
      });
    }
  }, [pageTitle, isLoading]);

  useEffect(() => {
    if (pageType !== 'cadastro' && (!nossaCookie || !user)) {
      navigate('/identifique-se');
    }
    setTimeout(() => {
      setLoader(false);
    }, 1000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageType, nossaCookie]);

  if (error) return <Error />;
  if (isLoading) return <Loader />;
  return <>{children}</>;
};

Main.defaultProps = {
  children: '',
  user: {},
  error: null,
  pageTitle: '',
  pageType: ''
};

Main.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  isLoading: PropTypes.bool.isRequired,
  setLoader: PropTypes.func.isRequired,
  user: PropTypes.shape({
    userInfo: PropTypes.object,
    authentication: PropTypes.object
  }),
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  pageTitle: PropTypes.string,
  pageType: PropTypes.string
};

export default props => <Main {...useContext(SessionContext)} {...props} />;
